export enum TransactionType {
  TT_UNSET = 'TT_UNSET', // Do not use, needed because of proto3 limitations
  TT_SIM_ACTIVATION = 'TT_SIM_ACTIVATION',
  TT_TOP_UP = 'TT_TOP_UP',
  TT_BALANCE_REMAINING_ADJUSTMENT = 'TT_BALANCE_REMAINING_ADJUSTMENT',
  TT_SIM_REMAINING_ADJUSTMENT = 'TT_SIM_REMAINING_ADJUSTMENT',
  TT_BALANCE_LIMIT_ADJUSTMENT = 'TT_BALANCE_LIMIT_ADJUSTMENT',
}
